import createIcon from '../../createIcon';

/**
 * @component @name Swipe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguODkgMTQuNzVMMTQuOCAxMi43MUMxNC41MiAxMi41NyAxNC4yMiAxMi41IDEzLjkxIDEyLjVIMTNWNi41QzEzIDUuNjcgMTIuMzMgNSAxMS41IDVDMTAuNjcgNSAxMCA1LjY3IDEwIDYuNVYxNy4yNEw2Ljc1IDE2LjVDNi40MiAxNi40MyA2LjA3IDE2LjUzIDUuODMgMTYuNzhMNSAxNy42Mkw5LjU0IDIyLjQxQzkuOTIgMjIuNzkgMTAuNjggMjMgMTEuMjEgMjNIMTcuMzdDMTguMzcgMjMgMTkuMjEgMjIuMjcgMTkuMzUgMjEuMjhMMTkuOTggMTYuODJDMjAuMSAxNS45NyAxOS42NiAxNS4xNCAxOC44OSAxNC43NVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMC4xMyAzLjg3QzE4LjY5IDIuMTcgMTUuNiAxIDEyIDFDOC40IDEgNS4zMSAyLjE3IDMuODcgMy44N0wyIDJWN0g3TDQuOTMgNC45M0M1LjkzIDMuNjQgOC42MyAyLjUgMTIgMi41QzE1LjM3IDIuNSAxOC4wNyAzLjY0IDE5LjA3IDQuOTNMMTcgN0gyMlYyTDIwLjEzIDMuODdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Swipe = createIcon('Swipe', [
  [
    'path',
    {
      d: 'M18.89 14.75L14.8 12.71C14.52 12.57 14.22 12.5 13.91 12.5H13V6.5C13 5.67 12.33 5 11.5 5C10.67 5 10 5.67 10 6.5V17.24L6.75 16.5C6.42 16.43 6.07 16.53 5.83 16.78L5 17.62L9.54 22.41C9.92 22.79 10.68 23 11.21 23H17.37C18.37 23 19.21 22.27 19.35 21.28L19.98 16.82C20.1 15.97 19.66 15.14 18.89 14.75Z',
      key: '14e5lz',
    },
  ],
  [
    'path',
    {
      d: 'M20.13 3.87C18.69 2.17 15.6 1 12 1C8.4 1 5.31 2.17 3.87 3.87L2 2V7H7L4.93 4.93C5.93 3.64 8.63 2.5 12 2.5C15.37 2.5 18.07 3.64 19.07 4.93L17 7H22V2L20.13 3.87Z',
      key: '3h87ju',
    },
  ],
]);

export default Swipe;
